module.exports = __webpack_public_path__ + "img/lighthouse.36543ece.svg";